import { goTo } from '@itau-loans-www/utils'

export default () => setTimeout(() => goTo('basic-data'), 1000)
